import { useStaticQuery, graphql } from 'gatsby';

export const useBibliographyJsonData = () => {
  const { allBibliographyfilters } = useStaticQuery(graphql`
    query {
      allBibliographyfilters {
        nodes {
          bibliography {
            ID
            Author
            Title
            PublicationYear
            BibliographyTypeID
            PublicationTitle
            ISBN
            ISSN
            DOI
            Url
            Pages
            TitleId
            Issue
            Volume
            JournalAbbreviation
            Publisher
            Place
            LinkAttachments
          }
          bibliographyTagFilters {
            BibliograhpyID
            BibliographyTagID
          }
          bibliographyType {
            ID
            Name
          }
          bibliographyTag {
            ID
            Name
          }
        }
      }
    }
  `);

  return { allBibliography: allBibliographyfilters };
};
